/**
 * ShowMap
 * 
 * @Author: Focci
 * @Date: 2023-07-31 23:05:13
 * @Last Modified by: Focci
 * @Last Modified time: 2023-07-31 23:05:13
 */

'use client'

import PropTypes from 'prop-types'
import Link from 'next/link'
import Switch from '@comp/form/Switch'
import { useCallback, useMemo } from 'react'
import { modeType, urls } from '@lib/parse'
import { useLocale, useTranslations } from 'next-intl'
import { omit, values } from 'lodash-es'
import { getListingCategory } from '@lib/parse/urls'
import { setListingMode } from '@lib/listing-mode'

export function getMapListingsUrl(type, param, locale, isMapListing) {
  const tmp = omit(param, values(modeType))
  const { value } = getListingCategory(param)
  
  // 添加分页标记
  if(tmp.page === undefined) tmp.page = 1
  tmp[modeType.listing] = value
  
  return urls.listing(type, tmp, locale, !isMapListing)
}

export default function ShowMap({
  isMapListing = false,
  type = '',
  searchParam = {},
}) {
  const locale = useLocale()
  const ts = useTranslations('search')
  
  const url = useMemo(
    () => getMapListingsUrl(type, searchParam, locale, isMapListing), 
    [type, searchParam, locale, isMapListing]
  )

  const handleClick = useCallback(() => {
    setListingMode(isMapListing ? modeType.listing : modeType.map)
  }, [isMapListing])

  return (
    <Link
      onClick={handleClick}
      href={url} 
      className="flex"
    >
      <div className="flex items-center gap-1 relative">
        <span className="whitespace-nowrap">{ts('displayMap')}</span>
        <Switch checked={isMapListing} />
        <span className="absolute inset-0" />
      </div>
    </Link>
  )
}

ShowMap.propTypes = {
  type: PropTypes.string,
  searchParam: PropTypes.object,
}
